import { datadogRum } from '@datadog/browser-rum';

import { env } from './env';

export const init = () => {
  datadogRum.init({
    applicationId: '8aab16f6-93bd-48ee-907d-73483e8fd9ec',
    clientToken: 'pub4017bbe5d0b620322684d9cf98b0fb6c',
    site: 'datadoghq.com',
    service: 'trade-partner-portal',
    env: env,
    sessionSampleRate: 100,
    trackUserInteractions: true,
    trackSessionAcrossSubdomains: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      'https://trade-partner-portal.apps.opendoor.com',
      'https://trade-partner.opendoor.com',
      'https://trade-partner-portal.apps-staging.opendoor.com',
      'https://trade-partner.simplersell.com',
    ],
  });
};
